import type { LoadRequest, PlayerInterface } from "@foundation-player/api";
import { Media } from "./media_player.types";

export abstract class Plugin {
  protected media: Media;

  public constructor(media: Media) {
    this.media = media;
  }

  /**
   * Add plugin related eventListener to player within this method
   */
  public addFoundationEventListener?(
    foundationPlayer: PlayerInterface,
    element: HTMLElement,
  ): void;

  /**
   * Add plugin related configuration to Foundation player within this method
   * https://docs.player.foundation/v2/api/type/load-request/#properties
   */
  public addFoundationLoadRequestProperties?(
    dataset?: DOMStringMap,
  ):
    | Partial<LoadRequest>
    | Promise<Partial<LoadRequest> | undefined>
    | undefined;

  /**
   * Add plugin related configuration to Foundation player within this method
   * https://docs.player.foundation/v2/api/type/load-request/#plugins
   */
  public addFoundationLoadRequestPlugins?(
    dataset?: DOMStringMap,
  ):
    | LoadRequest["plugins"]
    | Promise<LoadRequest["plugins"] | undefined>
    | undefined;

  /**
   * The implementation of this method decides whether the other public methods
   * of the plugin are executed
   */
  public abstract isEnabled(): boolean;
}
